import styled from 'styled-components';

import { ContentBoundary } from 'styles/CommonStyles';
import theme from 'styles/theme';

export const PageHeader = styled.div`
  background: ${(props) => props.theme.colors.primaryAccent};
  background-size: cover;
  border-bottom-left-radius: 80px;
  color: ${(props) => props.theme.colors.white};
  height: 4rem;

  display: flex;
  align-items: center;

  @media screen and (min-width: ${theme.minWidth.pico}) {
    height: 5.5rem;
    min-width: 100%;
  }

  @media screen and (min-width: ${theme.minWidth.nano}) {
    height: 10rem;
    min-width: 100%;
  }
`;

export const PageHeaderContent = styled.div`
  ${ContentBoundary}
`;

export const PageHeaderTitle = styled.h1`
  font-size: 1.4rem;

  @media screen and (min-width: ${theme.minWidth.pico}) {
    font-size: 1.8rem;
  }

  @media screen and (min-width: ${theme.minWidth.nano}) {
    font-size: 2.2rem;
  }
`;

export default PageHeader;
